export function getPath(url: string | null, locale?: string): string {
  if (!url) {
    return "";
  }
  let path: string;
  try {
    path = new URL(url).pathname;
  } catch {
    path = url.startsWith("/") ? url : `/${url}`;
  }

  return addLocalePrefix(path, locale);
}

function addLocalePrefix(path: string, locale?: string): string {
  if (!locale || !path) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const localePrefix = `/${locale}`;
  const normalizedLower = normalizedPath.toLowerCase();
  const localePrefixLower = localePrefix.toLowerCase();

  if (normalizedLower === localePrefixLower || normalizedLower.startsWith(`${localePrefixLower}/`)) {
    return normalizedPath;
  }

  return normalizedPath === "/" ? localePrefix : `${localePrefix}${normalizedPath}`;
}

export function normalizePathForCompare(path: string): string {
  if (!path) {
    return "";
  }

  let normalized = path.startsWith("/") ? path : `/${path}`;
  if (normalized.length > 1 && normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }

  try {
    normalized = decodeURIComponent(normalized);
  } catch {
    // Ignore malformed encodings and compare as-is.
  }

  try {
    normalized = normalized.normalize("NFC");
  } catch {
    // Some runtimes may not support normalization.
  }

  return normalized.toLowerCase();
}
